import { vendor } from "../../../es-MX/place/settings/vendor";

export const settings = {
	authKeysFeature: {
		phone: "Teléfono",
		email: "Correo electrónico",
		keySelectLabel: "Elija el tipo de clave",
		addKey: "Agregar Claves de autenticación",
		contactsInputLabel: "Agregue una o más claves para autenticación",
		contactsEmailInputPlaceholder: "Ingrese un correo válido (ej: correo@gmail.com)",
		contactsPhoneInputPlaceholder:
			"Ingrese un número de teléfono (ej: +55 (00) 0 00000000",
		btnAddKey: "Agregar claves de autenticación",
		btnCancelAddKey: "Cancelar",
		authKeyAreaTitle: "Autenticación de retiro",
		authKeyAreaSubtitle:
			"Registre claves (correo electrónico o teléfono) que se utilizarán para recibir el código de autenticación al solicitar un retiro.",
		selectContactKeyMessage: "Seleccione un tipo de claves",
		selectContactInputMessage: "Complete una clave de contacto",
		contactAlreadyExists: "¡Este contacto ya existe!",
		invalidEmail: "Correo electrónico inválido",
		invalidPhone: "Teléfono inválido. Debe contener DDI (ej: +5511999999999)",
		incompletePhone: "Número de teléfono incompleto. Ingrese todos los dígitos.",
		invalidDDI:
			"Solo se aceptan números telefónicos brasileños. Use el DDI +55 o déjelo en blanco.",
		errorCreatingAuthKeys: "Error al crear claves de autenticación",
		invalidContactsFound:
			"Se encontraron contactos inválidos. Verifique los datos e intente nuevamente.",
		errorCreatingSomeKeys: "Error al crear algunas claves: {{errors}}",
	},
	workingPeriod: {
		deletedPeriod: "Período eliminado.",
		addDaysAndTime: "Agregar días y horarios",
		addOpeningHours: "Agregar horario de funcionamiento",
		daysOfTheWeek: "Días de la semana",
		start: "Inicio",
		end: "Final",
		errors: {
			timeRequired: "Ingrese un formato de horario estándar",
			daysRequired: "Seleccione al menos 1 día",
			endTimeAfterStart: "Horario final debe ser mayor que el inicial",
		},
	},
	menu: {
		productsWeb: {
			title: "Productos Web",
			subtitle: "Configure Comanda Online, Pedido en la mesa y Entregue Já.",
		},
	},
	vendor,
	productsWeb: {
		title: "Productos Web",
		subtitle:
			"Configure el enlace y demás informaciones de Entregue Já y Pedido en la Mesa. ",
		saveChanges: "Guardar cambios",
		toastSuccess: "Configuraciones guardadas con éxito",
		availableTimeTitleDrawer: "Agregar días y horarios",
		deleteOperatingHoursModal: {
			title: "Eliminar horario de funcionamiento",
			descriptionPrefix: "Al eliminar, los días y horarios ",
			descriptionBold: "no serán",
			descriptionSuffix: " mostrados {{location}}.",
			cancel: "Cancelar",
			confirm: "Eliminar horario",
		},
		tabs: {
			general: "Información General",
			entregueja: "Entregue Já",
			namesa: "Pedido en la mesa",
			comanda: "Comanda Online",
		},
		availableTime: {
			addRangeTime: "Agregar horario",
			addDaysAndTime: "Agregar días y horarios",
			rangeTime: {
				from: "Desde",
				to: "Hasta",
				startTimeLabel: "Inicio",
				endTimeLabel: "Final",
			},
			daysOfTheWeekTitle: "Días de la semana",
			daysOfTheWeekSubtitle:
				"Seleccione los días de la semana de funcionamiento del establecimiento.",
			rangeTimeTitle: "Horarios",
			rangeTimeSubtitle:
				"Seleccione los horarios de los días de funcionamiento del establecimiento.",
			holidaysTitle: "Feriados",
			holidaysSubtitle:
				"Defina el horario de funcionamiento del establecimiento durante los feriados.",
		},
		timeSection: {
			title: "Tiempo promedio",
			subtitle: "Defina informaciones como tiempo promedio a ser mostradas al cliente",
			averageAwaitTimeLabel: "Tiempo promedio de espera",
			visibleInfoLabel: "Hacer visible",
			isWaitingTimeVisibleLabel: "Tiempo promedio de espera",
			isOpenStatusVisibleLabel: "Estado (abierto o cerrado)",
		},
		paymentMethodsSection: {
			title: "Formas de pago",
			subtitle:
				"Seleccione las formas en que el cliente podrá pagar en el sitio o en la entrega del pedido.",
		},
		deliveryTaxSection: {
			title: "Tarifa de entrega",
			subtitle: "Defina informaciones de tarifa de entrega a ser mostradas al cliente.",
			attendanceRadiusLabel: "Radio de atención",
			deliveryTaxTypeLabel: "Tipo de tarifa",
			deliveryFeeLabel: "Tarifa de entrega cobrada",
			fixedDeliveryFeeLabel: "Valor base",
			deliveryFeePerKmLabel: "Valor por Km",
			perKmLabel: "Valor base",
			valueLabel: "Valor por Km",
			addMoreTax: "Agregar una tarifa más",
			deliveryTaxType: {
				unique: "Única",
				baseRateWithVariableKm: "Tarifa base + variable",
				ratePerRadius: "Tarifa por radio",
			},
		},
		generalTab: {
			productsLabel: "Productos Web",
			productsSubtitle: "Revise la lista de productos web a ser configurados.",
			urlLabel: "Dirección URL",
			urlSubtitle:
				"Defina la dirección url de acceso para el Menú digital, Entregue Já, Pedido en la Mesa y Comanda Online.",
			slugInvalid: "El slug debe contener solo letras, números, guiones y guiones bajos",
			barLabel: "Vinculación de bar",
			barSubtitle:
				"Defina a qué bar estarán vinculados los menús creados a partir de la integración por delivery.",
			selectBarLabel: "Seleccione un bar",
			selectBarTooltip:
				"Solo es posible vincular un solo bar para los menús creados a partir de integraciones ",
			save: "Guardar cambios",
			tagInfo: {
				entregueja: "Delivery",
				namesa: "Prepago",
				comanda: "Postpago",
				cardapio: "Visualización",
			},
		},
		entregueja: {
			availableTimesSection: {
				title: "Horario de funcionamiento",
				subtitle: "Defina los días y horarios de funcionamiento de Entregue Já",
				deleteModalLocation: "en Entregue Já",
			},
		},
		namesa: {
			availableTimesSection: {
				title: "Horario de funcionamiento",
				subtitle: "Defina los días y horarios de funcionamiento del Pedido en la Mesa",
				deleteModalLocation: "en Pedido en la Mesa",
			},
		},
		comanda: {
			availableTimesSection: {
				title: "Horario de funcionamiento",
				subtitle: "Defina los días y horarios de funcionamiento de Comanda Online",
				deleteModalLocation: "en Comanda Online",
			},
		},
		establishmentAddress: {
			title: "Dirección del establecimiento",
			subtitle: "Información de la dirección del establecimiento",
			warningTitle: "Atención",
			warningMessage:
				"Los campos de dirección mostrados son solo para consulta; para modificarlos, comuníquese con nuestro equipo de soporte.",
			postalCode: "Código postal",
			state: "Estado",
			city: "Ciudad",
			neighborhood: "Barrio",
			street: "Calle",
			number: "Número",
			complement: "Complemento",
			complementPlaceholder: "Ej: tienda A",
		},
		establishmentContactSection: {
			title: "Contacto con establecimiento",
			subtitle: "Introduce el número de teléfono para que los clientes puedan contactar",
			phoneLabel: "Número de teléfono",
			invalidPhone:
				"Ingrese el número con código de país (10 a 15 dígitos). Ej.: +55 71 999991234",
		},
	},
};
